// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DnsSourceTypeSchema = z.enum(['USER_PROVIDED','DNS_BRUTEFORCE','REVERSE_DNS_LOOKUP','CERTIFICATE_ALT_SUBJECT','INTELLIGENCE','SUBDOMAIN_ENUMERATION','NAME_RESOLUTION','REVERSE_DNS','PASSIVE_DNS','BRAND_MONITOR','INTERMEDIATE','EXTERNAL_INTEGRATION'] as const);

export type DnsSourceTypeType = `${z.infer<typeof DnsSourceTypeSchema>}`

export default DnsSourceTypeSchema;
